import { render, staticRenderFns } from "./Motivos.vue?vue&type=template&id=f50a9efa&"
import script from "./Motivos.vue?vue&type=script&lang=js&"
export * from "./Motivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports